import { jsx as _jsx } from "react/jsx-runtime";
const InvalidRoute = () => {
    return (_jsx("section", { className: "p-5", children: _jsx("h1", { children: "Sorry, this route does not exist." }) }));
};
export default InvalidRoute;
